import * as types from '../../constants/rmg/EventActionTypes'
import {env} from '../../constants/Environment';
import {url} from '../../constants/rmg/settings';
import _ from 'lodash';

export function load(parent, start){
	return async function(dispatch){
        dispatch({
            type: types.REQUEST,
            start: start,
            id: parent
        });

        let keys = ['sports', 'categories', 'tournaments'];

        let search = parent.map((id, idx) => keys[idx] + '/' + id).join('/');

        console.log(search);

        const response = await fetch(url + '/' + search + '/events/' + start + '?withEvents=1');
        const result = await response.json();

        dispatch({
            type: types.RECEIVE,
            data: result.events,
            start: start,
            id: parent
        })
    }
}